import { useEffect, useRef } from 'react'

import { CardContainer } from '../../components/CardContainer/CardConteiner'
import { RecentCard } from '../../components/Cards/RecentCard'
import { useRecentContext } from '../../hooks/apiHooks/MentorHooks'
import useOnScreen from '../../hooks/useOnScreen'
import { useScrollToTop } from '../../hooks/useScrollToTop'
import { IContextGroup } from '../../types/contextGroup'

function RecentPage() {
  const observerTarget = useRef<HTMLDivElement | null>(null)
  const {
    data: recentMentorsData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useRecentContext()

  const needToFetch = useOnScreen(observerTarget, [hasNextPage])
  useScrollToTop()

  useEffect(() => {
    if (needToFetch && hasNextPage && !isFetchingNextPage) {
      void fetchNextPage()
    }
  }, [needToFetch])

  return (
    <div className="tc-mv-main-container">
      <CardContainer className="!gap-y-1" dataTestId="recent-cards-container">
        {recentMentorsData?.pages
          .map(page => page.items)
          .flat()
          .map((contextsGroup: IContextGroup) => (
            <RecentCard key={contextsGroup.id} contextsGroup={contextsGroup} />
          ))}
        {hasNextPage && (
          <div
            ref={observerTarget}
            className="pb-8 absolute bottom-0 w-full -z-10"
          />
        )}
      </CardContainer>
    </div>
  )
}

export default RecentPage
